module.exports = __webpack_public_path__ + "img/noZs-content-image.2a959696.svg";